exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nh4[data-v-b7539366] {\n  font-weight: bold;\n}\n.required-field > label[data-v-b7539366]::after {\n  content: \"*\";\n  color: red;\n  margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-b7539366] {\n  font-weight: 100;\n  color: red;\n  position: initial;\n  text-align: left;\n  height: auto;\n  width: auto;\n}\n.has-danger[data-v-b7539366] {\n  color: red;\n}\n.mt[data-v-b7539366] {\n  margin-top: 7px;\n}\n.gradientbt[data-v-b7539366] {\n  background: #0f6940;\n  color: white;\n}\n.box-body[data-v-b7539366] {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.collection_time_date_icon svg[data-v-b7539366] {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  right: 22px;\n  top: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b7539366","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/primaryTrip/addPrimaryTrip.vue
// module id = 229
// module chunks = 0